import { render, staticRenderFns } from "./ecommerceDetailModal.vue?vue&type=template&id=4e8d7e50&scoped=true&"
import script from "./ecommerceDetailModal.vue?vue&type=script&lang=ts&"
export * from "./ecommerceDetailModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8d7e50",
  null
  
)

export default component.exports